export interface CustomFieldFrontendSelectableOption {
  id: number;
  value: string;
}

export const INACTIVE_SELECTABLE_OPTION_ID = -1;
